import { BaseError } from './BaseError.js';
/**
 * Error thrown when user lacks required permissions.
 * Used for authorization failures when user is authenticated but not authorized.
 */
export class ForbiddenError extends BaseError {
    context;
    name = 'ForbiddenError';
    constructor(message, context, cause) {
        super(message, cause);
        this.context = context;
    }
}
//# sourceMappingURL=ForbiddenError.js.map